/**
 * Formats a raw phone number into a display
 * string with a leading + and space-separated groups.
 *
 * Assumes a 2-digit country code + 2-digit area/trunk code (DE/CH numbers), then
 * groups the remaining digits in blocks of three. Returns '' for empty input and
 * `+<digits>` for inputs too short to group.
 */
export const formatPhoneNumber = (raw?: string | null): string => {
  const digits = (raw ?? '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 4) return `+${digits}`;

  const countryCode = digits.slice(0, 2);
  const areaCode = digits.slice(2, 4);
  const rest = digits.slice(4).match(/.{1,3}/g) ?? [];

  return `+${countryCode} ${areaCode} ${rest.join(' ')}`;
};
